module.exports = __webpack_public_path__ + "img/preload-doc.d3f65fef.gif";